
$(document).ready(function(){



  // 08/12/2021  Home page- You may also like
  $('.custom-you-may-like').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    dots:false,
    infinite: false,
    arrows: true,

    responsive: [

      {
        breakpoint: 769,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: false,
          arrows: false,
          dots: true
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
          arrows: false,
          dots: true
        }
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          arrows: false,
          dots: true
        }
      }

    ]
  });


  $('.special-slider').slick({
    responsive: [

      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          arrows: false,
          dots: true
        }
      }
    ]
  });

  // product modal slider js start
//   $('.pro_modal_slider').slick({
//     slidesToShow: 1,
//     arrows: true,
//     dots: false,
//     cssEase: 'linear',  
//     focusOnSelect: false,
//   });

//   $( ".pro_modal_slider .slick-arrow ,.pro_modal_slider .slick-slide" ).on( "click", function() {
//     $(this).parents().parents('.product-media-modal').attr('open',true);
//     $('body').addClass('overflow-hidden');
//   });


  // product modal slider js end

  $('.one-half-column-left.custom-data ul').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 1500,
    dots:false,
    infinite: false,
    arrows: true,
    responsive: [

      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          autoplay: false,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          autoplay: false,
          slidesToScroll: 1
        }
      }

    ]
  });


  $('.home_main_banner').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    //     autoplaySpeed: 5000,
    //     speed:15000,
    dots:false,
    infinite: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          autoplay: false,
          dots: false,
          arrows: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          autoplay: false,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          autoplay: false,
          slidesToScroll: 1
        }
      }

    ]
  });

  //   08/12/2021 Megamenu Hover
  if (jQuery(window).width() > 1024) {
    let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
    console.log(items)
    items.forEach(item => {
      item.addEventListener("mouseover", () => {
                            item.setAttribute("open", true);
      item.querySelector("ul.custom-megamenu").addEventListener("mouseleave", () => {
                                                                item.removeAttribute("open");
    });
    item.addEventListener("mouseleave", () => {
                          item.removeAttribute("open");
  });
});

});

// Megamenu on hover class add remove
$("ul.custom-megamenu").hover(
  function () {
    $(".custom-hover-js-2").addClass("header__active-menu-item");
  },
  function () {
    $(".custom-hover-js-2").removeClass("header__active-menu-item");
  }
);

}


$(".header__icon--search").click(function () {
  // $(".tab").addClass("active"); // instead of this do the below 
  $(this).parents().find(".announcement-bar").addClass("hide");   
});

$(".icon.icon-close").click(function () {
  // $(".tab").addClass("active"); // instead of this do the below 
  $(this).parents().find(".announcement-bar").removeClass("hide");   
});



//  if (jQuery(window).width() <= 1024) {
//    $("img.caret-img").click(function () { 
//      $(".custom-hover-js-2.header__menu-item:hover span:after").addCss("display","none");
//      $(this).parents(".custom-hover-js-2.header__menu-item:hover span:after").addClass("display","block");
// //      $("summary").removeClass("header__menu-item");

//   });
// }
// else{
//   $('img.caret-img').on('click', function(){
//    function () {
//     $(".custom-hover-js-2").addClass("header__active-menu-item");
//   },
//   function () {
//     $(".custom-hover-js-2").removeClass("header__active-menu-item");
//   }
// });
// }


/* product detail image slider */

$('.product_slider .slider-for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  draggable:false,
  arrows:false,
  asNavFor: '.product_slider .slider-nav, .pro_modal_slider',  
  infinite: false,
  responsive: [     
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        draggable:true,
        arrows:true,
      }
    }
  ]
});





var item_length = $('.slick-slide').length - 1;
$('.product_slider .slider-nav').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  asNavFor: '.product_slider .slider-for, .pro_modal_slider',
  dots: false,   
  focusOnSelect: true, 
  vertical: true,
  verticalSwiping: false, 
  infinite: false,
  draggable:false,
  arrows: true,
 /* onAfterChange: function(slide, index){
    if( item_length == index ){
      alert("Slide 2");
    }
  },*/
  responsive: [     
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        vertical: false,
        verticalSwiping: true,
        mobileFirst:true,
        draggable:true,
        slidesToShow: 4,
        arrows: false

      }
    },
    {
      breakpoint: 768,
      settings: {
        vertical: false,
        verticalSwiping: true,
        mobileFirst:true,
        draggable:true,
        slidesToShow: 4,
        arrows:false

      }
    }

  ]
}); 

/* product detail image slider end */



/*$('.product_main_img img').click(function(){

  alert("hi");
  $('.product-media-modal__dialog')/*.modal('show');;
    $('body').toggleClass('model_open');
});
 */




// $('.product-media-modal__content').slick({
//     slidesToShow: 1,
//   slidesToScroll: 1,
//   autoplay: false,
//   autoplaySpeed: 3000,
//    asNavFor: '.product_slider .slider-for, .product_slider .slider-nav',  
//    dots:false,
//    infinite: true,
//   arrows: true,

//   responsive: [
//     {
//       breakpoint: 1025,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         infinite: true,
//         autoplay: true,
//         dots: false,
//         arrows: true
//       }
//     },
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow: 1,
//         autoplay: true,
//         slidesToScroll: 1
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 1,
//         autoplay: true,
//         slidesToScroll: 1
//       }
//     }

//   ]
//   });


// product page gallery popup Get the modal
var modal = document.getElementById('myModal');

/*$('.product_main_img img, .product__media-icon').click(function(){
    modal.style.display = "block";


});
 */
$('#myModal .close').click(function(){
  modal.style.display = "none";

});

$('.size-chart a').click(function(){
  document.getElementById('sizechartModal').style.display = "block";
  $('body').css('overflow','hidden');

});
$('#sizechartModal .close').click(function(){
  document.getElementById('sizechartModal').style.display = "none";
  $('body').css('overflow','scroll');

});

$(document).on('click','#ShowPickupAvailabilityDrawer',function(){   

  document.getElementById('availability-drawer').style.display = "block";
  $('body').css('overflow','hidden');

});

$('#availability-drawer .close, #availability-drawer .return-pd').click(function(){
  document.getElementById('availability-drawer').style.display = "none";
  $('body').css('overflow','scroll');

});





// Open cart drawer after add to cart button is clicked
/* $('.product-form__submit').one('click', function(){


    setTimeout(function(){document.getElementById('cart-drawer').style.display = "block"; }, 1500);
  });  */


$('.phone_wrapper').keypress(function (e) {    

  var charCode = (e.which) ? e.which : event.keyCode    

  if (String.fromCharCode(charCode).match(/[^0-9]/g))    

    return false;                        

});  

$('.forgot_your_password_wrapper').css('display','none');
$('.forgot_password_text').css('display','none');
$('.first').click(function() {
//   debugger;
  $('.login_main').css('display','none');
  $('.login_text').css('display','none');
  $('.forgot_your_password_wrapper').css('display','block');
  $('.forgot_password_text').css('display','block');
});

$('#forgot_pass').click(function() {
//   debugger;
  $('.forgot_your_password_wrapper').css('display','none');
  $('.login_text').css('display','block');
  $('.login_main').css('display','block');
  $('.forgot_password_text').css('display','none');
});


$(window).on('load',function() {
  $('#preloader').fadeOut(500);
  $('body').css('overflow','visible');
});


$('.scroll_down').on('click', function(e) {
  e.preventDefault();
  $('html, body').animate({ scrollTop: $($(this).attr('href')).offset().top - 140}, 1000, 'linear');
});

$('.custom_color').on('click', function(){
  $('.custom_color').removeClass('active');
  $(this).addClass('active');
});

$('.popup_btn').on('click', function(){
//   $('html').addClass('js-drawer-open');
});

$('a.fancybox-close').on('click', function(){
  
//   alert('jj');
  $('html').removeClass('js-drawer-open');
});

$('.size-chart').on('click', function(){
 $(this).parents('body').addClass('overflow-hidden');   
});

$('.size-chart-popup .close').on('click', function(){
   $('body').removeClass('overflow-hidden');
});


$('.custom-locations .tab-data').on('click', function(){
  $('.tab-data').removeClass('active');
  $(this).addClass('active');
});


// $('.product-media-modal__content').slick({
//   slidesToShow: 1,
//     slidesToScroll: 1,
//     autoplay: false,
//     autoplaySpeed: 1500,
//     dots:false,
//     infinite: false,
//     arrows: true
// });


// $(window).on('scroll', function () {


//   if ($(window).scrollTop() >= 300) {
//         $('sticky-header').addClass('sticky');
// }
//     else {
//         $('sticky-header').removeClass('sticky');
// }



//   var scrollTop     = $(window).scrollTop(),
//       elementOffset = $('sticky-header').offset().top,
//       distance      = (elementOffset - scrollTop);

//   var fixed = {
//     podition : "fixed",
//     top: "0"
//   };

//   var absolute = {
//     podition : "absolute",
//     top: "auto"
//   };

//   if (distance == 0 ){
//     $('sticky-header').css(fixed);
//   }
//   else{
//     $('sticky-header').css(absolute);
//   }
// });




$(document).on('click','.no-js-hidden .Color',function(evt){
     
    var color = $(this).val();

    var size = $('.no-js-hidden .Size:checked').val();

    var variant = size +" / "+ color;
    
    var size_dropdown = $(this).closest("section.single_product_section").find(".main_select");

    if(!size){

        var select_option = $(size_dropdown).find("option").filter(function(){return $(this).text().trim() == color});
      }else{

		var select_option = $(size_dropdown).find("option").filter(function(){return $(this).text().trim() == variant});
      }

    if($(size_dropdown).length > 0){

     // $(size_dropdown).val($(select_option).val());

      var id = $(select_option).attr('data-id');
      var price = $(select_option).attr('data-price');
      var image = $(select_option).attr('data-src');

      //alert(id);
      //alert(price);
      //alert(image);

      var slick_slide=$(this).closest("div.product").find(".slider-nav .slick-list .slick-slide");
      if($(slick_slide).length>0 ){

        var matched_image = $(slick_slide).filter(function(){return $(this).find("img").attr("data-src") == $(select_option).attr("data-media-src")});
        if(matched_image && matched_image.length > 0){
           // alert(matched_image.length);
         $(matched_image).click();
          //$('.product_slider .product_main_img img').attr("src",image);
        }
        
      }
      


    }

  }); 

$('.custom-locations').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  variableWidth: true,
  responsive: [
    {
      breakpoint: 1599,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      }
    }
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 2
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


// $('.pop_up_mobile_close_btn ').on('click', function(){debugger
// $('body').find('.fancybox-opened, .fancybox-overlay').addClass('pc');
// $('body').removeClass('pro_popup');
// });


});







